module.exports = __webpack_public_path__ + "img/files-w.38bbffae.svg";